import React from "react"
import PopupState, { anchorRef, bindTrigger, bindMenu } from "material-ui-popup-state"
import { Button, Menu, MenuItem } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles(() => ({
  menu: {
    marginTop: 5,
  },
}))

const DesktopPeopleButton = ({ onCreate }) => {
  const classes = useStyles()

  const handleCreate = (type, popupState) => {
    onCreate && onCreate(type)
    if (popupState) popupState.close()
  }

  return (
    <PopupState variant="popover" popupId="desktop-add-people">
      {(popupState) => (
        <>
          <Button
            variant="contained"
            color="primary"
            {...bindTrigger(popupState)}
            ref={anchorRef(popupState)}
            data-cy="Button-create-person"
          >
            Add people
          </Button>
          <Menu
            {...bindMenu(popupState)}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            className={classes.menu}
          >
            <MenuItem onClick={() => handleCreate("single", popupState)} data-cy="MenuItem-create-single-person">
              Add single person
            </MenuItem>
            <MenuItem onClick={() => handleCreate("multiple", popupState)} data-cy="MenuItem-create-multiple-people">
              Add multiple people
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  )
}

export { DesktopPeopleButton }
